"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseStdout = void 0;
const logLabel = /^\[\w+\]\s*/gm;
const digraph = /digraph([\s\S]*?)\}/g;
const errorLabel = /^\[ERROR\]/gm;
// Parse the output from 'mvn dependency:tree -DoutputType=dot'
function parseStdout(stdout) {
    if (errorLabel.test(stdout)) {
        throw new Error('Maven output contains errors.');
    }
    const digraphs = stdout.replace(logLabel, '').match(digraph);
    if (!digraphs) {
        throw new Error('Cannot find any digraphs.');
    }
    return digraphs;
}
exports.parseStdout = parseStdout;
//# sourceMappingURL=stdout.js.map